import {
  GET_ADMIN_PAYMENT_TERMS,
  GET_ADMIN_PAYMENT_TERMS_SUCCESS,
  GET_ADMIN_PAYMENT_TERMS_ERROR,
  UPDATE_ADMIN_PAYMENT_TERM,
  UPDATE_ADMIN_PAYMENT_TERM_SUCCESS,
  UPDATE_ADMIN_PAYMENT_TERM_ERROR,
  POST_ADMIN_PAYMENT_TERM,
  POST_ADMIN_PAYMENT_TERM_SUCCESS,
  POST_ADMIN_PAYMENT_TERM_ERROR
} from "./actionTypes"

export const getAdminPaymentTerms = (query_params, paginated) => {
  return {
    type: GET_ADMIN_PAYMENT_TERMS,
    payload: query_params,
    paginated: paginated
  }
}

export const getAdminPaymentTermsSuccess = (event) => ({
  type: GET_ADMIN_PAYMENT_TERMS_SUCCESS,
  payload: event
})

export const getAdminPaymentTermsError = (error) => ({
  type: GET_ADMIN_PAYMENT_TERMS_ERROR,
  payload: error
})

export const createAdminPaymentTerm = (insurance_carriers) => {
  return {
    type: POST_ADMIN_PAYMENT_TERM,
    payload: insurance_carriers,
  }
}

export const createAdminPaymentTermSuccess = (event) => ({
  type: POST_ADMIN_PAYMENT_TERM_SUCCESS,
  payload: event
})

export const createAdminPaymentTermError = (error) => ({
  type: POST_ADMIN_PAYMENT_TERM_ERROR,
  payload: error
})

export const updateAdminPaymentTerm = (insurance_carriers) => {
  return {
    type: UPDATE_ADMIN_PAYMENT_TERM,
    payload: insurance_carriers
  }
}

export const updateAdminPaymentTermSuccess = (event) => ({
  type: UPDATE_ADMIN_PAYMENT_TERM_SUCCESS,
  payload: event
})

export const updateAdminPaymentTermError = (error) => ({
  type: UPDATE_ADMIN_PAYMENT_TERM_ERROR,
  payload: error
})
